import { DefaultError, QueryClient, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  title: string;
  about_text_english: string;
  about_text_malay: string;
  about_text_mandarin: string;
  about_description_english: string;
  about_description_malay: string;
  about_description_mandarin: string;
  mobile_app_cards: string;
  aboutImage: string;
  ezpaz_text_english: string;
  ezpaz_text_malay: string;
  ezpaz_text_mandarin: string;
  ezpazImage: string;
  mobile_app_desc_english: string;
  mobile_app_desc_malay: string;
  mobile_app_desc_mandarin: string;
  androidQrImage: string;
  iosQrImage: string;
  bottomImage: string;
  android_text_english: string;
  android_text_malay: string;
  android_text_mandarin: string;
  ios_text_english: string;
  ios_text_malay: string;
  ios_text_mandarin: string;
  androidLink: string;
  iosLink: string;
}

const fetchAppAboutDetails = async (airport: string | null): Promise<DocumentDetailsResponse> => {
  if (!airport) throw new Error("Airport not found");
  const response = await passengerCMSApi.get(`/api/get-mobile-app-about-section/all?airport=${airport}`);
  return response.data[0];
};

export const useAppAboutDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  const [currentAirport] = useLocalStorage("currentAirport", null);

  return useQuery<DocumentDetailsResponse, DefaultError>(
    {
      queryKey: ["AppAboutDocumentDetails", id, currentAirport],
      enabled: !!id && !!currentAirport,
      queryFn: () => fetchAppAboutDetails(currentAirport),
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};
